module.exports = __webpack_public_path__ + "static/boxing.023782d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients/boxing.jpg
// module id = 72
// module chunks = 253514110161907 263791100135453 269829036549620